import {
  BarcodeDetector,
  prepareZXingModule,
  type BarcodeDetectorOptions,
} from "barcode-detector/ponyfill"
import zxingReaderWasmUrl from "zxing-wasm/reader/zxing_reader.wasm?url"

// Ship the decoder's wasm with our bundle instead of loading it from the library's CDN.
prepareZXingModule({
  overrides: {
    locateFile: (path: string, prefix: string) =>
      path.endsWith(".wasm") ? zxingReaderWasmUrl : prefix + path,
  },
})

export const createBarcodeDetector = (options: BarcodeDetectorOptions) =>
  new BarcodeDetector(options)
